export default __webpack_public_path__ + "d8d63b8e925aa74e28f3215e20b68e9a.svg";